import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import type { BooleanTuner } from '../BooleanTuner';

export class BooleanTuneCommand implements ICommand {
  private readonly _tuner: BooleanTuner;

  private readonly _descriptor: string;

  private readonly _val: boolean;

  public constructor(tuner: BooleanTuner, descriptor: string, val: boolean) {
    this._tuner = tuner;
    this._descriptor = descriptor;
    this._val = val;
  }

  public execute(): Promise<boolean> {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
    this._tuner.setValueAsync(this._descriptor, this._val);
    return Promise.resolve(true);
  }

  public undo(): Promise<boolean> {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
    this._tuner.setValueAsync(this._descriptor, !this._val);
    return Promise.resolve(false);
  }
}
